import { t } from "i18next";
import { FC } from "react";

export const AccesDenied: FC<any> = () => {
  return (
    <main className="relative isolate min-h-full">
      <img
        alt=""
        src="https://images.unsplash.com/photo-1545972154-9bb223aac798?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3050&q=80&exp=8&con=-15&sat=-75"
        className="absolute inset-0 -z-10 h-full w-full object-cover object-top"
      />
      <div className="mx-auto max-w-7xl px-6 py-6 text-center sm:py-20 lg:px-8">
        <p className="text-base font-semibold leading-8 text-white">403</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-5xl">
          {t("user.views.access_denied")}
        </h1>
        <p className="mt-4 text-base text-white/70 sm:mt-6">
          {t("user.views.access_denied_description")}
        </p>
        <div className="mt-10 flex justify-center">
          <a href="#" className="text-sm font-semibold leading-7 text-white">
            <span aria-hidden="true">&larr;</span>{" "}
            {t("user.views.page_not_found_description_three_one")}
          </a>
        </div>
        {/* Añade más items aquí */}
      </div>
    </main>
  );
};
